<header class="app-header">
  <div class="header-content">
    <a class="logo" routerLink="/dashboard">
      <img
        src="assets/images/WellSky®_Outlined_White_CMYK.svg"
        alt="WellSky"
        class="wellsky-logo"
      />
    </a>
    <nav class="header-nav">
      <span class="nav-title">Conversational Agents Dashboard</span>
    </nav>
    <span class="spacer"></span>
    @if (isAuthenticated$ | async) {
      <div class="user-menu">
        <button
          mat-button
          [matMenuTriggerFor]="userMenu"
          class="user-menu-button"
        >
          <mat-icon>account_circle</mat-icon>
          <span class="user-email">{{ userEmail$ | async }}</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    }
  </div>
</header>

<main class="app-main">
  <router-outlet></router-outlet>
</main>
